import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';

import DateRangePicker, { DateRangePickerProps } from '../DateRangePicker';

type ConnectedDateRangePickerProps<TFieldValues extends FieldValues> = UseControllerProps<TFieldValues> & Pick<DateRangePickerProps,
    'disablePast' |
    'disableFuture' |
    'minDate' |
    'maxDate' |
    'shouldDisableDate' |
    'readOnly' |
    'shortcutsKey'>;

function ConnectedDateRangePicker<TFieldValues extends FieldValues>({ 
    control, 
    name, 
    rules,
    ...rest 
}: ConnectedDateRangePickerProps<TFieldValues>) {
    return (
        <Controller 
            name={ name }
            control={ control }
            render={ ({ field: { ref, value, ...field }, fieldState }) => (
                <DateRangePicker
                    { ...field }
                    { ...rest }
                    error={ fieldState.error?.message }
                    shortcutsKey="availability"
                />
            ) }
        />
    );
}

export default ConnectedDateRangePicker;
